module.exports = __webpack_public_path__ + "static/assets/phone.fb6edf5e.jpg";